import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { agentService, utilService } from '../../../../core/services'
import * as interfaces from '../../../../static/interfaces'
import * as Hooks from '../../../../utils/hooks'
import { Button } from '../../../atoms'
import { EditTable } from '../../../organisms'
import { Panel } from '../../../atoms'
import SidebarLayout from '../../_layouts/sidebarLayout'
import GuideTourSkillBulkAssignmentModal from 'components/organisms/Guides/GuideTourSkillBulkAssignmentModal'

declare var window: interfaces.IWindow

interface IProps {
  skills: {
    agent_tour_skills: IJsonResponse
  }
  user: any
}

const COLUMNS = [
  {
    name: I18n.t('generic.name'),
    field: 'name',
    required: true,
  },
  {
    name: I18n.t('generic.position'),
    field: 'position',
    required: false,
  },
  {
    name: I18n.t('guide_tour_skill_bulk_assignment.assigned_guide_count'),
    field: 'assigned_guide_count',
    required: false,
  },
]

const AgentTourSkillsIndex: React.FC<IProps> = props => {
  Hooks.SetDocumentTitle('Agent tour skills')

  const { data, pagination } = agentService.getDataFromJson(props.skills.agent_tour_skills)
  const { data: userData } = utilService.getDataFromJson(props.user)
  const [tourSkills, setTourSkills] = React.useState(data)
  const handleDelete = React.useCallback(
    async id => {
      const response = await agentService.deleteTourSkills(id)
      // TODO 成功レスポンスと揃えたい
      window.flashMessages.addMessage({
        text: response.data.flush.message,
        type: response.data.flush.type,
      })
      setTourSkills(tourSkills.filter(tourSkill => tourSkill.id !== id))
    },
    [tourSkills]
  )

  const showBulkAssignmentModal = React.useCallback(() => {
    window.globalModal.showModal({
      small: true,
      topAligned: true,
      width: '640px',
      body: (
        <GuideTourSkillBulkAssignmentModal
          onSuccess={({ agentTourSkillId, createdCount }) => {
            setTourSkills(current =>
              current.map(tourSkill =>
                tourSkill.id === agentTourSkillId
                  ? {
                      ...tourSkill,
                      assigned_guide_count:
                        Number(tourSkill.assigned_guide_count || 0) + createdCount,
                    }
                  : tourSkill
              )
            )
          }}
        />
      ),
    })
  }, [])

  return (
    <SidebarLayout user={userData}>
      <Wrapper>
        <Panel
          title={
            <Heading>
              <div>
                <span>{I18n.t('generic.tour_skills')}</span>
                <Button small={true}>
                  <a href="/agent/agent_tour_skills/new">{I18n.t('generic.create_new')}</a>
                </Button>
              </div>
              <Button small={true} handleClick={showBulkAssignmentModal}>
                ガイドに一括付与
              </Button>
            </Heading>
          }
        >
          <EditTable
            editable={true}
            columns={COLUMNS}
            records={tourSkills}
            pagination={pagination}
            handleDelete={handleDelete}
            getEditLink={({ id }) => `/agent/agent_tour_skills/${id}/edit`}
          />
        </Panel>
      </Wrapper>
    </SidebarLayout>
  )
}

const Wrapper = styled.div`
  width: 100%;
  padding: 22px 40px 80px 46px;

  .Panel {
    max-width: none;
  }
`

const Heading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  .Button {
    margin-left: 12px;
  }
`

export default AgentTourSkillsIndex
